import React, { Component } from 'react'
import { BasicLazyParams } from '../../utile'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import { RadioButton } from 'primereact/radiobutton'
import ClassetStudentSearch from '../../classetComponents/classetStudentSearch'
import ClassetDropdown from '../../classetComponents/classetDropDown'
import Service from '../../services'
import { baseUrlAdmin, status } from '../../store/apiConstants'
import ClassetInputText from '../../classetComponents/classetInputText'
import { Toast } from 'primereact/toast'
import LoadingComponent from '../loadingComponent'
import { debounce } from 'lodash';
import BranchToSectionDD from '../BaseDropdownComponents/BranchToSectionDD'
import ClassetTextArea from '../../classetComponents/classetTextArea'
import ClassetStudentSearchFilter from '../Search/ClassetStudentSearchFilter'
import { parseFeeConcessionURL } from '../../utils/feeConcessionNavigation';
const searchTypeOptions = [
    { label: "Student Name", value: "studentName" },
    { label: "Enrollment Number", value: "enrollmentNumber" }
]



const feeConcessionTypesOptions = [
    { value: 'merit', label: 'Merit-based' },
    { value: 'sports', label: 'Sports' },
    { value: 'financial', label: 'Financial Aid' },
    { value: 'alumni', label: 'Alumni' },
    { value: 'staff', label: 'Staff Child' },
    { value: 'general', label: 'General' }
];



export class FeeConcession extends Component {
    constructor(props) {
        super(props);

        this.state = {
            lazyParams: BasicLazyParams,
            searchType: 1,
            searchInput: "",
            studentsData: [],
            openConcessionDialog: false,
            raiseData: [],
            RefundfeeData: [],
            studentId: '',
            searchLevel: 1,
            feeConcessionTypesOptions: feeConcessionTypesOptions,
            searchType: searchTypeOptions[0].value,
            totalRefundAmt: 0,
            first: 0,
            rows: 10,
            showConfirmDialog: false,
            modifiedConcessions: []
        };
        this.debouncedApiCall = debounce(this.getStudentData, 500)
        this.service = new Service();
        this.studentSearchRef = React.createRef();
    }

    componentDidMount() {
        // Parse URL parameters if they exist
        const urlParams = parseFeeConcessionURL(window.location.search);
        
        if (urlParams.studentId) {
            console.log('FeeConcession: URL params detected:', urlParams);
            
            // Set orgId in localStorage if provided
            if (urlParams.orgId) {
                localStorage.setItem('selectedOrgId', urlParams.orgId);
            }
            
            // Set searchLevel to 2 for student search
            this.setState({
                searchLevel: parseInt(urlParams.searchLevel) || 2
            }, () => {
                // Call setDropdownValues with studentId
                this.setDropdownValues({
                    studentIds: [urlParams.studentId]
                });
            });
        }
    }


    setDropdownValues = (dropdownsData) => {
        this.setState({
            dropdownsData,
            studentId: dropdownsData?.studentIds?.[0] || '', // Set first studentId if exists
            studentsData: [] // Clear previous data
        }, () => {
            if (dropdownsData?.studentIds?.length > 0) {
                // If studentIds exists from search, call getStudentData directly
                this.getStudentData();
                
                // Set selected students in search component after a delay to ensure ref is ready
                const attemptSetSelectedStudents = (attempts = 0) => {
                    if (attempts >= 20) {
                        console.log('FeeConcession: Max retry attempts reached for setSelectedStudents');
                        return;
                    }
                    
                    if (this.studentSearchRef?.current && typeof this.studentSearchRef.current.setSelectedStudents === 'function') {
                        console.log('FeeConcession: Calling setSelectedStudents with', dropdownsData.studentIds);
                        this.studentSearchRef.current.setSelectedStudents(dropdownsData.studentIds);
                    } else {
                        console.log('FeeConcession: Ref not ready, retrying...', attempts + 1);
                        setTimeout(() => attemptSetSelectedStudents(attempts + 1), 100);
                    }
                };
                
                setTimeout(() => attemptSetSelectedStudents(), 100);
            } else {
                // Otherwise call getStudents for dropdown population
                this.getStudents();
                this.getStudentData();
            }
        });
    }


    getStudentData = () => {

        this.setState({ isLoading: true })
        let academicYear = localStorage.getItem('userAcademicYear')
        let { lazyParams, dropdownsData, searchType, searchValue, studentId } = this.state;
        const { branchId, boardId, classId, sectionId } = dropdownsData
        let url = `${baseUrlAdmin}/concession/get-students?limit=${1000}&page=${lazyParams.page + 1}&search=`

        let username = searchType === 'studentName' ? searchValue : ""
        let enrollmentNo = searchType === 'enrollmentNumber' ? searchValue : ""
        let status = searchType === 'status' ? searchValue : ""

        let payload = {
            branchId,
            boardId,
            classId,
            sectionId,
            studentId,
            academicYear,
            username,
            enrollmentNo,
            status
        }

        // Updated condition to handle search properly
        if ((branchId && boardId && classId && sectionId) || studentId || username || enrollmentNo || status) {
            this.service.post(url, payload, true).then(data => {
                if (data?.status) {
                    // Filter data for single student if studentId is selected
                    let filteredData = data?.res?.data;
                    if (studentId && this.state.searchLevel === 2) {
                        filteredData = data?.res?.data?.filter(student => student.user_id === studentId);
                    }

                    this.setState({
                        studentsData: filteredData,
                        totalRecords: filteredData?.length || 0,
                        isLoading: false,
                    })
                } else {
                    this.setState({ isLoading: false })
                    this.toast.show({ severity: 'error', summary: 'Some error occured', detail: data.errMessage, life: 3000 });
                }
            }).catch(error => {
                this.setState({ isLoading: false })
                this.toast.show({
                    severity: 'error',
                    summary: 'Network error',
                    detail: 'An error occurred while processing your request.',
                    life: 3000
                });
            })
        } else {
            this.setState({ isLoading: false });
        }
    }

    getStudents = () => {
        let academicYear = localStorage.getItem('userAcademicYear')
        this.setState({ isLoading: true })
        let url = `${baseUrlAdmin}/fine/student?status=Active`; // Add status filter
        let payload = {
            "branchId": this.state.dropdownsData?.branchId,
            "boardId": this.state.dropdownsData?.boardId,
            "classId": this.state.dropdownsData?.classId,
            "sectionId": this.state.dropdownsData?.sectionId,
            "academicYear": academicYear,
            status: 'Active' // Add to payload as well
        }
        if (payload?.sectionId) {
            this.service.post(url, payload, true).then(data => {
                const studentsData = data?.res?.data.map(each => {
                    return {
                        label: each?.name,
                        value: each?.user_id
                    }
                })

                if (data?.status) {
                    this.setState({
                        students: studentsData,

                        isLoading: false
                    })

                } else {
                    this.setState({ isLoading: false })
                    this.toast.show({ severity: 'error', summary: 'Some error occured', detail: data.errMessage, life: 3000 });
                }

            }).catch(error => {
                this.setState({ isLoading: false })

            })
        } else {
            this.setState({ isLoading: false });
        }
    }

    getRaiseConcessionsData = () => {
        this.setState({ isLoading: true })
        let academicYear = localStorage.getItem('userAcademicYear')
        let { lazyParams } = this.state;
        let url = `${baseUrlAdmin}/concession/get-feetype-terms/${this.state?.studentInfo?.user_id}?academicYear=${academicYear}`

        this.service.get(url, true).then(data => {
            const total = data?.res?.data?.agg?.reduce((accumulator, each) => {
                if (each.concession !== undefined) {
                    accumulator += Number(each.concession);
                }
                return accumulator;
            }, 0);

            if (data?.status) {
                this.setState({
                    raiseData: data?.res?.data?.agg,
                    isLoading: false,
                    totalRecords: data?.res?.data?.agg.length,
                    totalConcessionRaised: total
                })

            } else {
                this.setState({ isLoading: false })
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: data.errMessage, life: 3000 });
            }

        }).catch(error => {
            this.setState({ isLoading: false })

        })
    }

    getFeeTypesData = () => {
        this.setState({ isLoading: true })
        let academicYear = localStorage.getItem('userAcademicYear')
        let { lazyParams } = this.state;
        let url = `${baseUrlAdmin}/fee-refund/fee-types`
        let payload = {
            user_id: this.state?.studentInfo?.user_id,
            academicYear: academicYear
        }
        this.service.post(url, payload, true).then(data => {

            if (data?.status) {
                this.setState({
                    RefundfeeData: data?.res?.data,
                    isLoading: false,
                    totalRecords: data?.res?.data?.length,
                    totalRefundAmt: data?.res?.totalRefundAmt
                })

            } else {
                this.setState({ isLoading: false })
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: data.errMessage, life: 3000 });
            }

        }).catch(error => {
            this.setState({ isLoading: false })

        })
    }

    onHandleConcession = (data) => {
        console.log(data, "studentInfo")
        this.setState({
            openConcessionDialog: true,
            studentInfo: data
        }, () => { this.getRaiseConcessionsData() })
    }
    onHandleConcessionClose = () => {
        this.setState({
            openConcessionDialog: false,
            raiseData: [],
            studentInfo: {},
            concessionRaisingRemarks: "",
        })
    }


    handleSetSearchValue = (value) => {
        this.setState({
            searchValue: value,
            dropdownsData: {
                boardId: '',
                branchId: "",
                classId: '',
                sectionId: '',
            },
            studentsData: [] // Clear previous data
        }, () => {
            this.debouncedApiCall()
        })
    }
    handleSearchLevel = (value) => {

        this.setState({
            searchLevel: value,
            studentId: "",
            searchValue: "",
            studentsData: [] // Clear data when switching modes
        })
    }

    onStudentChange = (e) => {
        this.setState({
            studentId: e.value,
            studentsData: [] // Clear previous data
        }, () => {
            this.getStudentData()
        })

    }


    handleTermWisePercentageValue = (e, rowData) => {
        let concessionAmt = Number(e.target.value)
        if (rowData.dueAmount > 0) {
            if (rowData?.dueAmount >= concessionAmt) {
                const updatedData = this.state.raiseData.map(item => {
                    if (item._id === rowData._id) {
                        return { ...item, currentConAmt: concessionAmt };
                    }
                    return item;
                });
                this.setState({ raiseData: updatedData });
            }

        }
    };


    handleConcessionType = (e, rowData) => {

        const updatedData = this.state.raiseData.map(item => {
            if (item._id === rowData._id) {
                return { ...item, concessionType: e.target.value };
            }
            return item;
        });
        this.setState({ raiseData: updatedData });
    }


    handleSetSearchTypeValue = (value) => {

        this.setState({ searchType: value }, () => {
            if (this.state.searchType == "studentName") {
                this.setState({ isUserNameSearch: true, })
            } else {
                this.setState({ isUserEnrollSearch: true, })
            }

        })
    }

    handleRaiseConcessionClick = () => {
        const { studentInfo, raiseData } = this.state;

        let modifiedConcessions = raiseData.filter((el) => {
            return el?.currentConAmt && el?.concessionType;
        });

        if (modifiedConcessions.length === 0) {
            this.toast.show({
                severity: 'warn',
                summary: 'No Changes',
                detail: 'Please enter concession details for at least one fee term',
                life: 3000
            });
            return;
        }

        this.setState({
            showConfirmDialog: true,
            modifiedConcessions
        });
    }

    hideConfirmDialog = () => {
        this.setState({
            showConfirmDialog: false,
            modifiedConcessions: []
        });
    }

    onHandleRaiseConcession = () => {
        this.setState({
            isLoading: true
        })
        const { studentInfo } = this.state


        let payload = {
            user_id: studentInfo?.user_id,
            academicYear: studentInfo?.user_info?.academicYear,
            branchId: studentInfo?.user_info?.branchId,
            boardId: studentInfo?.user_info?.boardId,
            gradeId: studentInfo?.user_info?.classId,
            sectionId: studentInfo?.user_info?.sectionId,
            enrollmentId: studentInfo?.enrollmentId,
            username: studentInfo?.user_info?.username,
            sectionName: studentInfo?.user_info?.sectionName,
            branchName: studentInfo?.user_info?.branchName,
            boardName: studentInfo?.user_info?.["custom:board"],
            gradeName: studentInfo?.user_info?.["custom:grade"],
            contactPersonName: studentInfo?.user_info?.contactPersonName,
            parentContactNo: studentInfo?.user_info?.parentContactNo,
            firstName: studentInfo?.user_info?.firstName,
            lastName: studentInfo?.user_info?.lastName,
            isClosed: false,
            concessionsRaised: [],
            concessionRaisingRemarks: this.state.concessionRaisingRemarks,
        }
        this.state?.raiseData?.filter((el) => {
            if (el?.currentConAmt || el?.concessionType) {
                el.isClosed = false
                payload?.concessionsRaised.push(el)
            }
        })
        let flag = payload?.concessionsRaised?.every((each) => {
            if (each.currentConAmt !== undefined && each.currentConAmt !== "" && each.concessionType !== undefined && each.concessionType !== "") {
                return true
            } else {
                return false
            }
        })

        let url = `${baseUrlAdmin}/concession/addConcession`;
        if (payload?.concessionsRaised?.length && flag) {
            this.service.post(url, payload, true).then(data => {
                if (data.status && data.res.status) {

                    this.setState({
                        isLoading: false,
                        openConcessionDialog: false,
                        raiseData: [],
                        concessionRaisingRemarks: "",
                        showConfirmDialog: false,
                        modifiedConcessions: []

                    })
                    this.toast?.show({ severity: 'success', summary: 'Success', detail: data.res.message, life: 3000 });
                    this.getStudentData()
                } else {
                    this.setState({
                        isLoading: false
                    })
                    this.toast?.show({ severity: 'error', summary: 'Error', detail: data.errMessage, life: 3000 });

                }
            });
        } else {
            this.setState({
                isLoading: false
            })
            this.toast?.show({ severity: 'error', summary: 'Please Enter All the required Concession Type and TermWise Value Fields', detail: 'Validation failed' });
        }

    }

    onPage = (event) => {
        this.setState({
            first: event.first,
            rows: event.rows
        });
    }

    render() {
        return (
            <div className="ma-main">

                <div className=" datatable-crud-demo ma-m30 mx-2 mb-5">



                    {/* <div style={{ marginLeft: "100px" }} className="flex justify-content-start align-items-center">
                        <span className="">OR</span>
                    </div> */}
                    <div className="flex">
                        <div className="flex flex-column justify-content-center align-items-center mt-3">
                            <RadioButton inputId="ingredient1" onChange={(e) => this.handleSearchLevel(1)} checked={this.state.searchLevel === 1} />
                        </div>

                        <div>
                            <BranchToSectionDD selectedValue={this.state.searchLevel} setValues={this.setDropdownValues} />
                        </div>
                    </div>

                    <div className="flex mt-4">
                        <div className="flex flex-column justify-content-center align-items-center mt-3">
                            <RadioButton inputId="ingredient2" onChange={(e) => this.handleSearchLevel(2)} checked={this.state.searchLevel === 2} />
                        </div>

                        <div className="field ml-4">
                            {/* <ClassetStudentSearch selectedValue={this.state.searchLevel} handleTypeValue={this.handleSetSearchTypeValue} handleSearchValue={this.handleSetSearchValue} />
                             <ClassetStudentSearchFilter
                                selectedValue={this.state.searchLevel}
                                ref={this.studentSearchRef}
                                setValues={this.setDropdownValues}
                                singleSelectInput={true}
                            /> */}

                            <ClassetStudentSearchFilter
                                selectedValue={this.state.searchLevel}
                                ref={this.studentSearchRef}
                                setValues={this.setDropdownValues}
                                singleSelectInput={true}
                                onStudentSelect={(studentId) => {
                                    this.setState({
                                        studentId,
                                        studentsData: [] // Clear previous data
                                    }, () => {
                                        this.getStudentData();
                                    });
                                }}
                                disabled={this.state.searchLevel !== 2}
                            />
                        </div>
                    </div>


                </div>

                <DataTable ref={(el) => this.dt = el}
                    value={this.state.studentsData}
                    dataKey="id"
                    paginator
                    first={this.state.first}
                    rows={this.state.rows || 10}
                    responsiveLayout="scroll"
                    className="dataTableValuesText"
                    showGridlines
                    selectionMode={'checkbox'}
                    columnResizeMode="expand"
                    resizableColumns
                    onPage={this.onPage}
                    totalRecords={this.state.studentsData.length}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                >

                    <Column filterField="studentName" field="user_info.given_name" sortable bodyClassName='text-center' header="Student Name" alignHeader={"center"} />
                    <Column filterField="enrollmentNo" field="user_info.username" sortable bodyClassName='text-center' header="Enrollment No" alignHeader={"center"}
                        body={(rowData, { rowIndex }) => {
                            return (

                                <p>{(rowData?.user_info?.username)?.slice(3)}</p>
                            )
                        }} />
                    <Column filterField="grade" sortable bodyClassName='text-center' header="Grade-Section" alignHeader={"center"} body={(rowData, { rowIndex }) => {
                        return (

                            <p>{rowData ? `${rowData?.user_info?.["custom:grade"]} - ${rowData?.user_info?.["sectionName"]}` : null}</p>
                        )
                    }} />
                    < Column filterField="board" field="user_info.custom:board" sortable bodyClassName='text-center' header="Board" alignHeader={"center"} />
                    <Column bodyClassName='text-center' header="Concession" alignHeader={"center"} body={(rowData, { rowIndex }) => {
                        return (
                            <div className='custom-fee-pay '>
                                <Button className='text-center' style={{ backgroundColor: '#076EFF', border: '1px solid #076EFF' }} onClick={() => this.onHandleConcession(rowData)}>
                                    <p className='payButton pl-2' style={{ color: rowData.totalDue !== 0 ? "#ffffff" : "#C6CED2" }}>Raise</p>
                                </Button>
                            </div>



                        )
                    }} />

                </DataTable>

                <Dialog
                    isopen={this.state.openConcessionDialog}
                    visible={this.state.openConcessionDialog}
                    className="w-11"
                    draggable={false}
                    onHide={this.onHandleConcessionClose}
                    closable={true}
                    header={() => {
                        return (<div className='mt-2 mb-4'>
                            <h3 className="formhead text-center ">Raise Concession</h3>

                        </div>)
                    }}
                    footer={() => (
                        <div className='flex justify-content-center  align-items-center mb-4'>
                        </div>
                    )}

                >

                    <>
                        <div className='grid m-2'>
                            <div className="col-4 " >
                                <label className='ma-label-s2 font-serif font-semibold text-900 text-lg'>Student Name</label>
                                <div className="mt-2">
                                    <ClassetInputText
                                        id='studentName'
                                        className=""
                                        height="48px"
                                        width="368px"
                                        value={this.state.studentInfo?.user_info?.given_name}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-4 " >
                                <label className='ma-label-s2 font-serif font-semibold text-900 text-lg'>Enrollment No</label>
                                <div className="mt-2">
                                    <ClassetInputText
                                        id='enrollmentId'
                                        height="48px"
                                        width="368px"
                                        value={(this.state.studentInfo?.user_info?.username)?.slice(3)}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-4" >
                                <label className='ma-label-s2 font-serif font-semibold text-900 text-lg'>Grade</label>
                                <div className="mt-2">
                                    <ClassetInputText
                                        id='grade'
                                        height="48px"
                                        width="368px"
                                        value={this.state.studentInfo?.user_info?.['custom:grade']}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-4" >
                                <label className='ma-label-s2 font-serif font-semibold text-900 text-lg'>Section</label>
                                <div className="mt-2">
                                    <ClassetInputText
                                        id='section'
                                        height="48px"
                                        width="368px"
                                        value={this.state.studentInfo?.user_info?.sectionName}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-4" >
                                <label className='ma-label-s2 font-serif font-semibold text-900 text-lg'>Board</label>
                                <div className="mt-2">
                                    <ClassetInputText
                                        id='board'
                                        height="48px"
                                        width="368px"
                                        value={this.state.studentInfo?.user_info?.['custom:board']}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-4 mt-4" >
                                <p className='ma-label-s2 font-serif concession-amt'>Total Concession Raised: <span className='underline' style={{ color: "green" }}>{this.state.totalConcessionRaised}</span></p>
                            </div>

                        </div>

                        <DataTable ref={(el) => this.dt = el}
                            value={this.state?.raiseData}
                            dataKey="id"
                            paginator
                            rows={10}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            globalFilter={this.state.globalFilter}
                        >

                            <Column filterField="feeType" field="feeType" sortable bodyClassName='text-center' header="Fee Type" alignHeader={"center"} />
                            <Column filterField="feeTermName" sortable bodyClassName='text-center' header="Fee Term Name" alignHeader={"center"} body={(rowData, index) => {
                                return (
                                    <p>{`${rowData?.paymentTerm}`}</p>
                                )
                            }} />
                            <Column filterField="termWiseActualValue" field="termWiseActualValue" sortable bodyClassName='text-center' header="Term wise Actual Fee" alignHeader={"center"}
                                body={(rowData, { rowIndex }) => {
                                    return <div className="flex justify-content-center">{` ${Math.round((rowData?.termWiseActualValue) * 100) / 100}`}</div>;

                                }} />
                            <Column filterField="concession" field="concession" sortable bodyClassName='text-center' header="Concession" alignHeader={"center"} />
                            <Column filterField="amountPaid" field="amountPaid" sortable bodyClassName='text-center' header="Paid Fee" alignHeader={"center"}
                                body={(rowData, { rowIndex }) => {
                                    return <div className="flex justify-content-center">{` ${Math.round(((rowData?.amountPaid || 0)) * 100) / 100}`}</div>
                                }
                                }

                            />
                            <Column bodyClassName='text-center' header="Concession Type" alignHeader={"center"} body={(rowData, index) => {

                                return (
                                    <>
                                        <ClassetDropdown
                                            id='paymentType'
                                            className=""
                                            height="48px"
                                            width="150px"
                                            options={this.state.feeConcessionTypesOptions}
                                            value={rowData?.concessionType || ""}
                                            onChange={(e) => this.handleConcessionType(e, rowData)}
                                            placeholder="Select Concession Type"
                                            disabled={
                                                rowData?.dueAmount > 0
                                                    ? rowData?.termWiseActualValue === 0
                                                        ? true
                                                        : rowData?.isUnassignApprovalRaised
                                                    : true
                                            }


                                        />
                                    </>
                                )
                            }} />
                            <Column bodyClassName='text-center' header="Term wise Value" alignHeader={"center"} body={(rowData, index) => {

                                return (
                                    <>
                                        <ClassetInputText
                                            className="text-xl"
                                            type="text"
                                            height="48px"
                                            width="150px"
                                            placeholder={!(rowData?.currentConAmt) ? 'Enter Value' : ''}
                                            value={rowData?.dueAmount > 0 ? rowData?.currentConAmt || '' : rowData?.currentConAmt || 0}
                                            onChange={(e) => {
                                                const value = e.target.value;
                                                if (value.match(/^\d*\.?\d{0,2}$/)) {
                                                    this.handleTermWisePercentageValue(e, rowData);
                                                }
                                            }}
                                            onWheel={(e) => e.target.blur()}
                                            disabled={
                                                rowData?.dueAmount > 0
                                                    ? rowData?.termWiseActualValue === 0
                                                        ? true
                                                        : rowData?.isUnassignApprovalRaised
                                                    : true
                                            }

                                        />
                                    </>
                                )
                            }} />
                            <Column filterField="concessionValue" field="termWisePercentageOrValue" sortable bodyClassName='text-center' header="Concession Value" alignHeader={"center"} body={(rowData, index) => {
                                return (<p>{rowData?.currentConAmt || 0}</p>
                                )
                            }} />
                            <Column filterField="totalDue" field="" sortable bodyClassName='text-center' header="Total Due" alignHeader={"center"} body={(rowData, index) => {

                                let dueAmount = (Number(rowData?.dueAmount || 0))
                                let conAmt = Number(rowData?.currentConAmt) || 0
                                let finalDue = Number(dueAmount - conAmt).toFixed(2)
                                return (
                                    <p>{finalDue}</p>
                                )
                            }} />

                        </DataTable>
                        <div className="m-4" >
                            <p className="transport-fee-form-label">Remarks</p>
                            <div className="flex">
                                <ClassetTextArea
                                    placeholder='Remarks'
                                    className=""
                                    width={650}
                                    height={80}
                                    value={this.state.concessionRaisingRemarks}
                                    onChange={(e) => this.setState({ concessionRaisingRemarks: e.target.value })}
                                />
                            </div>
                        </div>

                        <div className='flex justify-content-center  align-items-center mt-4'>
                            <Button label='Raise Concession'
                                className='submitButtonn mr-4 button text-lg'
                                onClick={this.handleRaiseConcessionClick} />
                            <Button className='cancelButtonn'
                                onClick={this.onHandleConcessionClose}>
                                <p className='cancelButtonnText'>Cancel</p>
                            </Button>
                        </div>

                    </>
                </Dialog>

                <Dialog
                    visible={this.state.showConfirmDialog}
                    className="w-8"
                    draggable={false}
                    closable={true}
                    headerClassName='text-center font-semibold'
                    onHide={this.hideConfirmDialog}
                    header="Confirm Concession Details"
                    footer={
                        <div className='flex justify-content-center align-items-center'>
                            <Button label='Confirm & Raise' className='submitButtonn mr-4' onClick={this.onHandleRaiseConcession} />
                            <Button className='cancelButtonn'
                                onClick={this.hideConfirmDialog}>
                                <p className='cancelButtonnText'>Cancel</p>
                            </Button>
                        </div>
                    }
                >
                    <DataTable value={this.state.modifiedConcessions}>
                        <Column field="feeType" header="Fee Type" className='text-center' />
                        <Column field="paymentTerm" header="Term" className='text-center' />
                        <Column field="concessionType" header="Concession Type" className='text-center' />
                        <Column field="currentConAmt" header="Concession Amount" className='text-center' />
                        <Column body={(rowData) => {
                            // const dueAmount = (Number(rowData?.dueAmount || 0) - Number(rowData?.refundAmt || 0));
                            const dueAmount = (Number(rowData?.dueAmount || 0));
                            const conAmt = Number(rowData?.currentConAmt) || 0;
                            return (Number(dueAmount - conAmt)).toFixed(2);
                        }} header="Final Due"  className='text-center'/>
                    </DataTable>
                    <div className='flex justify-content-start align-items-center mt-4'>
                        <h5>Remarks : {this.state.concessionRaisingRemarks}</h5>
                    </div>
                    <div className='flex justify-content-start align-items-center mt-3'>
                        <h5 className="">Total Concession Amount : {this.state.modifiedConcessions.reduce((total, item) => total + Number(item.currentConAmt || 0), 0).toFixed(2)}</h5>
                    </div>
                </Dialog>

                <Toast ref={(el) => this.toast = el} position="bottom-right" />
                {this.state.isLoading && <LoadingComponent />}
            </div>
        )
    }
}

export default FeeConcession